<template>
  <ul class="doughnut-footer">
    <doughnut-chart-footer-item v-for="(label, index) in data.labels"
                                :key="index"
                                :label="label"
                                :value="datasetItemValue(index)"
                                :total="total"
                                :index="index" />

  </ul>
</template>

<script>
    import DoughnutChartFooterItem from '@components/chart/DoughnutChartFooterItem'
    import colors from '@packages/colors'
    import _ from 'lodash'

    export default {
      components: {
        DoughnutChartFooterItem
      },

        props: {
            dataName: {
                type: String
            },

            value: {
                type: Object
            }
        },

        computed: {
            data() {
                if (this.value)
                    return this.value

                return this.$store.state.statistics[this.dataName]
            },

            total() {
                return _.sum(this.data.datasets[0].data)
            },

            dataSet() {
                return this.data.datasets[0]
            }
        },

        methods: {
            color(index) {
                return colors.charts.doughnut[index]
            },

            datasetItemValue(index) {
                if (!this.data.datasets)
                    return

                return this.data.datasets[0].data[index]
            },

            percentage(value) {
                return this.total !== 0 ? Math.round(value / this.total * 100) : 0
            },
        },
    }
</script>

<style lang="scss" scoped>
li {
  width: 100%;
  display: grid;
  grid-template-columns: 30px auto auto 40px;
  font-size: 16px;

  &:not(:first-child) {
    margin-top: 14px;
  }

  > * {
    display: flex;
    align-items: center;
  }

  .circle {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    border: 3px solid;
  }

  .label {
    margin-right: 6px;
  }

  @media (max-width: 1700px) {
    font-size: 14px;
  }
}
</style>
